var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-6 py-8",attrs:{"fluid":""}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"slot":"progress","color":"primary","indeterminate":""},slot:"progress"}):_vm._e(),_c('message',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }